export default __webpack_public_path__ + "static/media/sky.ab85770d.png";